import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";

const NAV_LINKS = [
  { label: "Auto disponibili", href: "/auto" },
  { label: "Come funziona", href: "/#verifica" },
  { label: "Chi siamo", href: "/#chisiamo" },
  { label: "Contatti", href: "/#contatti" },
];

const Logo = ({ dark = false }) => (
  <Link
    to="/"
    className="flex items-center gap-1.5 select-none"
    aria-label="Carmaps home"
  >
    <span
      className="text-[1.35rem] font-bold tracking-[-0.04em]"
      style={{ color: dark ? "#fff" : "var(--cm-ink)" }}
    >
      CARMAPS
    </span>
    <span
      className="mt-1 h-[7px] w-[7px] rounded-full"
      style={{ background: "var(--cm-green)" }}
    />
  </Link>
);

export { Logo };

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
      style={{
        background: scrolled ? "rgba(241,240,236,0.82)" : "transparent",
        backdropFilter: scrolled ? "blur(14px)" : "none",
        borderBottom: scrolled ? "1px solid var(--cm-line)" : "1px solid transparent",
      }}
    >
      <div className="mx-auto max-w-[1360px] px-6 lg:px-10">
        <div className="flex h-[70px] items-center justify-between">
          <Logo />

          <nav className="hidden items-center gap-9 lg:flex">
            {NAV_LINKS.map((l) => (
              <Link
                key={l.label}
                to={l.href}
                className="text-[0.9rem] text-[#4a4a45] transition-colors duration-200 hover:text-[var(--cm-ink)]"
              >
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="hidden items-center gap-3 lg:flex">
            <Link
              to="/#vendi"
              className="rounded-full border border-[var(--cm-line)] bg-transparent px-5 py-2.5 text-[0.85rem] font-medium transition-all duration-200 hover:border-[var(--cm-ink)]"
            >
              Richiedi una valutazione
            </Link>
            <Link
              to="/auto"
              className="rounded-full bg-[var(--cm-ink)] px-5 py-2.5 text-[0.85rem] font-medium text-white transition-transform duration-200 hover:scale-[1.03]"
            >
              Scopri le auto
            </Link>
          </div>

          <button
            className="lg:hidden"
            onClick={() => setOpen((v) => !v)}
            aria-label="Menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className="overflow-hidden lg:hidden"
        style={{
          maxHeight: open ? "420px" : "0px",
          transition: "max-height 0.4s cubic-bezier(0.22,1,0.36,1)",
          background: "rgba(241,240,236,0.98)",
          backdropFilter: "blur(14px)",
        }}
      >
        <div className="flex flex-col gap-1 px-6 pb-6 pt-2">
          {NAV_LINKS.map((l) => (
            <Link
              key={l.label}
              to={l.href}
              onClick={() => setOpen(false)}
              className="border-b border-[var(--cm-line)] py-3 text-[1.05rem]"
            >
              {l.label}
            </Link>
          ))}
          <div className="mt-4 flex flex-col gap-3">
            <Link
              to="/#vendi"
              onClick={() => setOpen(false)}
              className="rounded-full border border-[var(--cm-line)] px-5 py-3 text-center text-[0.95rem] font-medium"
            >
              Richiedi una valutazione
            </Link>
            <Link
              to="/auto"
              onClick={() => setOpen(false)}
              className="rounded-full bg-[var(--cm-ink)] px-5 py-3 text-center text-[0.95rem] font-medium text-white"
            >
              Scopri le auto
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}
